import { FC, memo } from 'react'

import { Color } from '../constants'

import styles from '../star-rating.module.scss'

interface IRatingIcon {
  index: number
  isActive: boolean
}

const RatingIcon: FC<IRatingIcon> = ({ index, isActive }: IRatingIcon) => {
  const fill = isActive ? Color.YELLOW : Color.GREY
  return (
    <div data-rating={index} className={styles.ratingIcon}>
      <svg
        className={styles.starIcon}
        fill={fill}
        stroke={fill}
        width="25"
        height="24"
        viewBox="0 0 25 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="square"
          strokeWidth="1"
          d="M11.556,2.7a1,1,0,0,1,1.888,0L15.4,8.274a1,1,0,0,0,.918.669l5.878.152a1,1,0,0,1,.586,1.791L18.1,14.507a1,1,0,0,0-.348,1.073l1.676,5.7a1,1,0,0,1-1.53,1.1L13.071,19.03a1,1,0,0,0-1.141,0L7.105,22.381a1,1,0,0,1-1.53-1.1l1.676-5.7A1,1,0,0,0,6.9,14.507L2.221,10.885a1,1,0,0,1,.586-1.791l5.878-.152A1,1,0,0,0,9.6,8.274Z"
        />
      </svg>
    </div>
  )
}

export default memo(RatingIcon)
